import React, { useState } from 'react';
import {
  Box,
  Container,
  CircularProgress
} from '@mui/material';
import ServiceList from './ServiceList';
import ServiceForm from './ServiceForm';

const Service = () => {
  const [currentView, setCurrentView] = useState('list'); // 'list', 'form'
  const [editingService, setEditingService] = useState(null);

  const handleCreateService = () => {
    setEditingService(null);
    setCurrentView('form');
  };

  const handleEditService = (service) => {
    setEditingService(service);
    setCurrentView('form');
  };

  const handleBackToList = () => {
    setCurrentView('list');
    setEditingService(null);
  };

  const handleSaveService = () => {
    setCurrentView('list');
    setEditingService(null);
  };

  const renderCurrentView = () => {
    switch (currentView) {
      case 'list':
        return (
          <ServiceList
            onEdit={handleEditService}
            onCreate={handleCreateService}
          />
        );
      case 'form':
        return (
          <ServiceForm
            service={editingService}
            onSave={handleSaveService}
            onCancel={handleBackToList}
          />
        );
      default:
        return (
          <Box display="flex" justifyContent="center" alignItems="center" minHeight="400px">
            <CircularProgress />
          </Box>
        );
    }
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
        py: 3
      }}
    >
      <Container maxWidth="xl">
        {renderCurrentView()}
      </Container>
    </Box>
  );
};

export default Service;
